'use client'

import Image from "next/image";
import { Box, Button, Typography } from "@mui/material";
import { simpleDateFormatter } from "@/src/utils/dateFormatter";
import type Comment from "@/src/_types/Comment/comment";

const CommentsList = ({
    comments = [],
    handleReply,
    depth = 0
}: {
    comments?: Comment[];
    handleReply?: any;
    depth?: number;
}) => {

    return (
        comments.map((comment: Comment, index: number) => (
            <Box
                display={"flex"}
                alignItems={"start"}
                gap={1}
                mb={1}
                key={`comment-${index}`}
            >
                <Box
                    borderRadius={"50%"}
                    overflow={"hidden"}
                    width={50}
                    height={50}
                >
                    <Image
                        src={'/images/default-user-avatar.png'}
                        alt={`${comment.author_name} Avatar`}
                        width={75}
                        height={75}
                        style={{
                            width: '100%',
                            height: 'auto'
                        }}
                    />
                </Box>
                <Box pt={.25}>
                    <Box mb={1}>
                        <Typography 
                            color={"primary.main"}
                        >
                            {comment.author_name}
                        </Typography>
                        <Typography 
                            fontSize={10} 
                            color={"secondary"}
                        >
                            {
                                simpleDateFormatter(comment.created_at)
                            }
                        </Typography>
                        <Typography 
                            fontSize={'.8rem'} 
                            color={"text.primary"} 
                            mb={.5}
                        >
                            {comment.body}
                        </Typography>
                        <Button
                            size="small"
                            color="primary"
                            onClick={() => handleReply(comment.id)}
                        >
                            <Typography
                                variant={"caption"}
                                color={"primary"}
                                textTransform={"capitalize"}
                            >
                                Reply
                            </Typography>
                        </Button>
                    </Box>
                    {
                        comment.replys &&
                        comment.replys.length > 0 &&
                        (
                            <CommentsList
                                comments={comment.replys}
                                handleReply={handleReply}
                                depth={depth + 1}
                            />
                        )
                    }
                </Box>
            </Box>
        ))
    );
};

export default CommentsList;